import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAccountVesselScope } from '../../hooks/useAccountVesselScope';
import ListBase from '../../modules/wrh/List';
import FormBase from '../../modules/wrh/Form';
import CompliancePageBase from '../../modules/wrh/CompliancePage';
import WeeklyReportPageBase from '../../modules/wrh/WeeklyReportPage';
import ArrangementsPageBase from '../../modules/wrh/ArrangementsPage';
import MonthSheetPageBase from '../../modules/wrh/MonthSheetPage';
import RestRecordReportPageBase from '../../modules/wrh/reports/RestRecordReportPage';
import RulesReportPageBase from '../../modules/wrh/reports/RulesReportPage';
import ComplianceReportPageBase from '../../modules/wrh/reports/ComplianceReportPage';
import WeeklySummaryReportPageBase from '../../modules/wrh/reports/WeeklySummaryReportPage';
import RulesPage from '../../modules/wrh/RulesPage';
import { List as OperationTypesList, Form as OperationTypesForm, Detail as OperationTypesDetail } from '../../modules/vessel-operation-types';
import VesselOperationsSchedulePageBase from '../../modules/vessel-operations/VesselOperationsSchedulePage';

export const List: React.FC = () => <ListBase />;

export const Form: React.FC = () => {
  const vesselId = useAccountVesselScope();
  if (vesselId == null) return <Navigate to="/login" replace />;
  return <FormBase lockedVesselId={vesselId} />;
};

export { RulesPage };
export { OperationTypesList, OperationTypesForm, OperationTypesDetail };
export { OperationTypesList as OperationTypesPage };

export const CompliancePage: React.FC = () => {
  const vesselId = useAccountVesselScope();
  if (vesselId == null) return <Navigate to="/login" replace />;
  return <CompliancePageBase lockedVesselId={vesselId} />;
};

export const WeeklyReportPage: React.FC = () => {
  const vesselId = useAccountVesselScope();
  if (vesselId == null) return <Navigate to="/login" replace />;
  return <WeeklyReportPageBase lockedVesselId={vesselId} />;
};

export const ArrangementsPage: React.FC = () => {
  const vesselId = useAccountVesselScope();
  if (vesselId == null) return <Navigate to="/login" replace />;
  return <ArrangementsPageBase lockedVesselId={vesselId} />;
};

export const MonthSheetPage: React.FC = () => {
  const vesselId = useAccountVesselScope();
  if (vesselId == null) return <Navigate to="/login" replace />;
  return <MonthSheetPageBase lockedVesselId={vesselId} />;
};

export const RestRecordReportPage: React.FC = () => <RestRecordReportPageBase />;

export const RulesReportPage: React.FC = () => <RulesReportPageBase />;

export const ComplianceReportPage: React.FC = () => <ComplianceReportPageBase />;

export const WeeklySummaryReportPage: React.FC = () => <WeeklySummaryReportPageBase />;

export const VesselOperationsSchedulePage: React.FC = () => {
  const vesselId = useAccountVesselScope();
  if (vesselId == null) return <Navigate to="/login" replace />;
  return <VesselOperationsSchedulePageBase lockedVesselId={vesselId} />;
};

export { default as VesselOperationsReportPage } from '../../modules/vessel-operations/reports/VesselOperationsReportPage';
